module.exports = __webpack_public_path__ + "static/media/reporting_only_business.c132c11d.png";